import React, { useMemo, useState } from "react";
import { ColorTemplateCheckMark } from "components/charts/ColorTemplatesPage";
import {
  SELECTABLE_APP_LANGUAGES,
  languageDisplayName,
  loadAppLanguageId,
  saveAppLanguage,
  t,
} from "utils/appLanguage";

export default function LanguagePage({ languageId, onSelect }) {
  const selectedId = languageId || loadAppLanguageId();
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return SELECTABLE_APP_LANGUAGES;
    return SELECTABLE_APP_LANGUAGES.filter((lang) => {
      const hay = `${lang.label} ${lang.native} ${lang.code}`.toLowerCase();
      return hay.includes(q);
    });
  }, [query]);

  const pick = (id) => {
    saveAppLanguage(id);
    onSelect?.(id);
  };

  return (
    <div className="fx-language-page">
      <div className="fx-language-page__search">
        <label className="fx-language-page__search-field">
          <span className="fx-language-page__search-icon" aria-hidden>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="6.25" stroke="currentColor" strokeWidth="1.8" />
              <path d="M16 16.5L20 20.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </span>
          <input
            type="search"
            className="fx-language-page__search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("search", selectedId)}
            aria-label={t("search", selectedId)}
          />
        </label>
      </div>
      <ul className="fx-language-page__list" role="listbox" aria-label={t("language", selectedId)}>
        {filtered.map((lang) => {
          const active = selectedId === lang.id;
          return (
            <li key={lang.id}>
              <button
                type="button"
                role="option"
                aria-selected={active}
                className={`fx-language-page__row${active ? " fx-language-page__row--active" : ""}`}
                onClick={() => pick(lang.id)}
              >
                <span className="fx-language-page__label">{languageDisplayName(lang)}</span>
                {active ? (
                  <span className="fx-language-page__check" aria-label="Selected">
                    <ColorTemplateCheckMark />
                  </span>
                ) : (
                  <span className="fx-language-page__check fx-language-page__check--empty" />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
